import { render, staticRenderFns } from "./MitManagerDashboardPage.vue?vue&type=template&id=dea9a122&scoped=true"
import script from "./MitManagerDashboardPage.vue?vue&type=script&lang=js"
export * from "./MitManagerDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./MitManagerDashboardPage.vue?vue&type=style&index=0&id=dea9a122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea9a122",
  null
  
)

export default component.exports